module.exports = __webpack_public_path__ + "img/19.402f5e11.png";